export const trancatString = (characterLimit, originalString) => {
  if (originalString.length <= characterLimit) return originalString;

  return (
    originalString.substring(0, 14) +
    "..." +
    originalString.substring(originalString.length - 3, originalString.length)
  );
};
